var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#1E1850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3479 24.0303V24.1765H18.4941H19.319H19.3365H19.4827V24.0303V16.7646C19.4827 14.95 20.9617 13.4711 22.7763 13.4711H27.8658H28.012V13.3248V12.5V12.3538H27.8658H22.7763C20.3263 12.3538 18.3479 14.3322 18.3479 16.7822V24.0303Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4652 26.0312V25.885H19.319H18.4941H18.3479V26.0312V36.5787V36.7249H18.4941H19.319H19.4652V36.5787V26.0312Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4036 39.0724V39.2186H26.5498H31.6217H31.6393V39.2185C34.0815 39.209 36.0501 37.2164 36.0501 34.7902V25.7695V25.6233H35.9039H35.0791H34.9328V25.7695V34.8077C34.9328 36.6224 33.4539 38.1013 31.6393 38.1013H26.5498H26.4036V38.2475V39.0724Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0677 14.9922V14.846H35.9215H35.0967H34.9505V14.9922V24.0304V24.1766H35.0967H35.9215H36.0677V24.0304V14.9922Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3585 27.3884H34.4056L34.4438 27.3609L39.4982 23.7281L39.8668 23.4632H39.4129H15.001H14.547L14.9156 23.7281L19.97 27.3609L20.0083 27.3884H20.0553H34.3585ZM36.3787 24.598L34.0482 26.2711H20.3832L18.0527 24.598H36.3787Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5721 26.8203V26.6741H27.4259H26.6011H26.4549V26.8203V33.6121V33.7583H26.6011H27.4259H27.5721V33.6121V26.8203Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5721 16.75V16.6038H27.4259H26.6011H26.4549V16.75V24.0157V24.1619H26.6011H27.4259H27.5721V24.0157V16.75Z",
    fill: "#CBDB2A",
    stroke: "#CBDB2A",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtsActive);
export default __webpack_public_path__ + "static/media/courts-active.98f1bb3034434ad621e0d25e83310cba.svg";
export { ForwardRef as ReactComponent };